import { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import LandingPricingSection from "@/components/LandingPricingSection";
import { Button } from "@/components/ui/button";
import { CreditCard, Sparkles, UserPlus } from "lucide-react";

const steps = [
  {
    icon: UserPlus,
    title: "1. Sign up free",
    body: "Create your account as a Groover. No card, no payment, no commitment at registration.",
  },
  {
    icon: Sparkles,
    title: "2. Explore the platform",
    body: "Discover events, venues, creators and music with full free access to the community.",
  },
  {
    icon: CreditCard,
    title: "3. Add Creator or Venue in-app",
    body: "Open your profile, choose the add-on you need and pay securely in ZAR. Your account upgrades instantly.",
  },
];

const Pricing = () => {
  useEffect(() => {
    document.title = "Pricing | Metro City Groove";
    document.querySelector('meta[name="description"]')?.setAttribute(
      "content",
      "Join Metro City Groove free. Creator and Venue tools are optional in-app add-ons you activate whenever you're ready."
    );
  }, []);

  return (
  <>
    <Header />
    <main className="min-h-screen bg-black text-white pt-24">
      <section className="container mx-auto px-4 py-10 sm:py-16 text-center max-w-3xl">
        <h1 className="text-3xl sm:text-5xl font-bold tracking-tight">Pricing</h1>
        <p className="mt-4 text-base sm:text-lg text-gray-400">
          Every account starts free. Paid tiers are add-ons inside the app — never a paywall at sign up.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild className="bg-white text-black hover:bg-gray-200 w-full sm:w-auto">
            <Link to="/auth">Create Free Account</Link>
          </Button>
          <Button asChild variant="outline" className="border-white/30 bg-transparent text-white hover:bg-white/10 w-full sm:w-auto">
            <Link to="/agency-pricing">Agency Consultation</Link>
          </Button>
        </div>
      </section>

      <section className="container mx-auto px-4 pb-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-5xl mx-auto">
          {steps.map(({ icon: Icon, title, body }) => (
            <div key={title} className="rounded-2xl border border-white/15 bg-white/[0.03] p-5">
              <Icon className="w-6 h-6 text-white mb-3" />
              <h2 className="font-semibold text-lg">{title}</h2>
              <p className="text-sm text-gray-400 mt-2">{body}</p>
            </div>
          ))}
        </div>
      </section>

      <LandingPricingSection />

      <section className="container mx-auto px-4 pb-20 text-center max-w-2xl">
        <p className="text-sm text-gray-500">
          Add-ons are billed monthly in ZAR and can be cancelled at any time. Venue accounts also complete a quick
          business verification before going live.
        </p>
      </section>
    </main>
  </>
  );
};

export default Pricing;
